import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = {
  class: "d-flex align-items-center",
  style: {"width":"200px"}
}
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Liste des mouvements")
    ], -1)),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.point_ventes.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Filtrer par Point de vente ", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.point_vente,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.point_vente) = $event)),
                      options: _ctx.point_ventes,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      placeholder: "Sélectionner un point de vente"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Type Operation ", -1)),
              _createVNode(_component_Multiselect, {
                searchable: true,
                options: _ctx.lestypes,
                modelValue: _ctx._type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx._type) = $event)),
                placeholder: "Choisir"
              }, null, 8, ["options", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Magasin ", -1)),
              _createVNode(_component_Multiselect, {
                options: _ctx.magasinOptions,
                searchable: true,
                modelValue: _ctx._magasin,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._magasin) = $event)),
                placeholder: "Sélectionner le magasin"
              }, null, 8, ["options", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Produit ", -1)),
              _createVNode(_component_Multiselect, {
                modelValue: _ctx._produit,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._produit) = $event)),
                options: _ctx.produitOptions,
                searchable: true,
                disabled: _ctx.prodEtat,
                placeholder: "Sélectionner un produit"
              }, null, 8, ["modelValue", "options", "disabled"])
            ])
          ])
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("table", _hoisted_15, [
          _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Produit "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Magasin "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Quantite "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Type Opération "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Motif "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Référence "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Statut ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mouvements, (mouvement, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_16, _toDisplayString(mouvement.proCondiMagInventaire?.nomProd), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(mouvement.proCondiMagInventaire?.procondimag?.magasin?.nomMagasin), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(mouvement.qte), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(mouvement.typeOperation), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(mouvement?.motifsSuivi?.libelle), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(mouvement?.refMov), 1),
                _createElementVNode("td", _hoisted_22, [
                  (mouvement.statut === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[8] || (_cache[8] = [
                        _createElementVNode("span", { class: "badge badge-danger" }, "En attente", -1)
                      ])))
                    : _createCommentVNode("", true),
                  (mouvement.statut === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[9] || (_cache[9] = [
                        _createElementVNode("span", { class: "badge badge-success" }, "Valider", -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}